module.exports = __webpack_public_path__ + "static/media/testkit3.18d6baef.jpg";